export class RecyclingFolder {
  constructor(
    technicalId,
    boomerangId,
    clientCompanyName,
    status,
    depositDate,
    manufacturerBoomerangId,
    productBoomerangId,
    productDetail,
    productSerialNumber,
    repairFileBoomerangId,
    buybackDetail,
    networkBoomerangId,
    storeBoomerangId,
    attachmentList,
    hasDefaultProduct,
    createdAt,
    createdBy
  ) {
    this.technicalId = technicalId
    this.boomerangId = boomerangId
    this.clientCompanyName = clientCompanyName
    this.status = status
    this.depositDate = depositDate
    this.manufacturerBoomerangId = manufacturerBoomerangId
    this.productBoomerangId = productBoomerangId
    this.productDetail = productDetail
    this.productSerialNumber = productSerialNumber
    this.repairFileBoomerangId = repairFileBoomerangId
    this.buybackDetail = buybackDetail
    this.networkBoomerangId = networkBoomerangId
    this.storeBoomerangId = storeBoomerangId
    this.attachmentList = attachmentList
    this.hasDefaultProduct = hasDefaultProduct
    this.createdAt = createdAt
    this.createdBy = createdBy
  }
}
